<template>
  <div>
    <div class="heading-4">Unagii Account</div>
    <template v-if="isUser">
      <update-account />
      <v-divider class="mt-10 mb-10"></v-divider>
      <change-password />
    </template>
    <div v-else class="mt-10 p-relative">
      <img src="@/assets/img/signup-banner.png" class="width-100 z-index-1" />
      <div
        class="d-flex flex-column justify-center px-10 z-index-2 p-absolute width-100 height-100"
        style="top: 0"
      >
        <div class="heading-3">
          Yield smarter with an Unagii Account
        </div>
        <div class="mt-6">
          <div class="d-flex align-center">
            <v-icon small color="primary">fa-check-circle</v-icon>
            <div class="text-4 darkgray--text ml-3">
              Instant access to consolidated portfolio across products anywhere
            </div>
          </div>
          <div class="d-flex align-center mt-3">
            <v-icon small color="primary">fa-check-circle</v-icon>
            <div class="text-4 darkgray--text ml-3">
              Stay updated with latest news and exclusive notifications
            </div>
          </div>
          <div class="d-flex align-center mt-3">
            <v-icon small color="primary">fa-check-circle</v-icon>
            <div class="text-4 darkgray--text ml-3">
              Potential to earn campaign bonuses
            </div>
          </div>
        </div>
        <div class="mt-6">
          <c-btn @click="$store.dispatch('showAuthModal', 'GetStarted')"
            >Sign Up Now</c-btn
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import UpdateAccount from "./components/UpdateAccount";
import ChangePassword from "./components/ChangePassword";

export default {
  name: "AccountSettings",
  components: {
    UpdateAccount,
    ChangePassword,
  },
  computed: {
    ...mapGetters({
      isUser: "auth/isUser",
    }),
  },
};
</script>
